import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';
import { condensedStyles } from 'core/components/theme/condensed-layout';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: 720,
    ...condensedStyles(theme, { width: '100%', maxWidth: 720 }),
    margin: '0 auto',
    padding: theme.spacing(6, 6, 4),
    overflow: 'hidden'
  },
  overflowContainer: {
    composes: '$container',
    overflow: 'visible'
  },
  subtitle: {
    fontSize: 14
  },
  withBottomLine: {
    borderBottom: `1px solid ${theme.onCardDivider.beige_25_op_30}`,
    paddingBottom: theme.spacing(5),
    marginBottom: theme.spacing(5)
  },
  noMegaDownPayWarning: {
    backgroundColor: theme.colorPalette.green_100,
    width: '100%',
    height: 88,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    padding: theme.spacing(7, 5),
    marginTop: theme.spacing(3),
    borderRadius: theme.sizes.innerCorners,
    marginBottom: theme.spacing(4),
    ...reskinStyles(theme, { backgroundColor: theme.colorPalette.beige_25, borderRadius: theme.sizes.innerCorners })
  },
  billingDetails: {
    marginTop: theme.spacing(4)
  },
  warningText: {
    color: theme.onCard.beige_50,
    marginLeft: theme.spacing(4),
    width: 524
  },
  button: {
    marginTop: theme.spacing(4)
  },
  advancedContainer: {
    padding: theme.spacing(6)
  },
  fullWidthLabel: {
    width: '100%'
  },
  marginTop: {
    marginTop: theme.spacing(2)
  },
  directBillingDescription: {
    fontSize: 10,
    fontWeight: 400,
    color: theme.onCard.white,
    marginTop: theme.spacing(-4),
    marginBottom: theme.spacing(2)
  }
}));

export default useStyles;
